import { Link } from 'react-router-dom'

import Button, { ButtonSize, ButtonVariant } from '../../../components/ui/button'
import TinyInvoiceLogo from '../../../components/ui/logo'

export type NavBarContentProps = {
  /** Use plain anchors (for static HTML generation). */
  staticLinks?: boolean
}

const signInButtonClass = 'button btn btn-light btn-sm button--width-auto'

const NavBarContent = ({ staticLinks }: NavBarContentProps) => {
  return (
    <nav className='navbar navbar-expand-md container col-xxl-8'>
      <div className='container d-flex justify-content-between'>
        <a href='/' className='navbar-brand'><TinyInvoiceLogo /></a>
        <div className='d-flex align-items-center'>
          {staticLinks ? (
            <a href='/pricing' className='d-none d-sm-block me-4 text-dark text-decoration-none'>Pricing</a>
          ) : (
            <Link to='/pricing' className='d-none d-sm-block me-4 text-dark text-decoration-none'>Pricing</Link>
          )}
          {staticLinks ? (
            <a href='/login' className={signInButtonClass}>Sign in</a>
          ) : (
            <Button as='link' to='/login' variant={ButtonVariant.SECONDARY} size={ButtonSize.SMALL}>
              Sign in
            </Button>
          )}
        </div>
      </div>
    </nav>
  )
}

export default NavBarContent
